import { useAppSelector } from "@/shared/lib/redux"
import {  selectUser } from "../../model"
import { morph } from "@/shared/lib/word-morph"
import { useMemo } from "react"

const roles = {
    'employees': 'Сотрудник',
    'users': 'Пользователь'
}

export const UserBadges = () => {
    const user = useAppSelector(selectUser)
    const userAge = useMemo(() => {
        const birthDate = new Date(user.date_of_birth);
        const today = new Date();
        
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();

        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
    
        return age;
    }, [user])

    return (
        <div className="flex flex-wrap gap-[10px] self-start">
            <div className="text-color-acid text-base font-semibold bg-color-dark uppercase rounded-full px-3 py-[6px]">
                {roles[user.role_id]}
            </div>
            {(Boolean(user.date_of_birth) && userAge > 0) &&
                <div className="text-color-dark text-base font-semibold bg-color-primary uppercase rounded-full px-3 py-[6px]">
                    {userAge} {morph(userAge, ['год', 'года', 'лет'])}
                </div>
            }
            {user.is_deleted && (
                <div className="text-amber-800 text-base font-semibold bg-amber-100 uppercase rounded-full px-3 py-[6px]">
                    Удалён
                </div>
            )}
            {user.is_blocked && !user.is_deleted && (
                <div className="text-red-700 text-base font-semibold bg-red-100 uppercase rounded-full px-3 py-[6px]">
                    Заблокирован
                </div>
            )}
        </div>
    )
}